module.exports = __webpack_public_path__ + "static/media/wildstreak_gypsyriches.750d9592.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/wildstreak_gypsyriches.png
// module id = 1371
// module chunks = 1